export default __webpack_public_path__ + "static/media/404-right.e0241a28.svg";